import useEmployees from './useEmployees';

export default useEmployees;
